import { Component, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
    templateUrl: 'info-dialog.component.html',
    styleUrls: ['info-dialog.component.scss'],
    imports: [MatToolbar, MatIcon, MatButton]
})
export class InfoDialogComponent {
  dialogRef = inject<MatDialogRef<InfoDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);


  onOk() {
    this.dialogRef.close(false);
  }
}
